import React, { useEffect } from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import "./traupdatemultiplepotmodal.scss";
import { getActiveEmployerObj } from "../../helpers/trautil";

const TRAUpdateMultiplePotModal = (props) => {
  const { individualMembershipData, setPotItem, potItem } = props;
  function handleCheck(item) {
    setPotItem(item);
  }

  useEffect(() => {
    handleCheck(potItem);
  }, [potItem]);

  return (
    <div className="tra-multipot-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="tra-multipot-modal-body">
        <p className="heading">{props.modalTitle}</p>
        <p className="description">
          You can have a single Target Retirement Age (TRA) across all of your
          TPT pots, or
          <p>
            alternatively you can manage them one at a time. Select which pot
            you would like to edit.
          </p>
        </p>
        <Row className="pot-view-container">
          <Col lg={4} md={3} sm={3} xs={12}>
            <div
              className={
                // Showing
                potItem === null ? "pot-item pot-item-bg" : "pot-item"
              }
            >
              <div className="most-popular">
                <div className="most-popular-text">MOST POPULAR</div>
              </div>
              <CustomCheckbox
                defaultChecked={potItem === null ? true : false}
                name="pot"
                potId="default"
                variantName="custom-checkbox text-end"
                onChange={(e) =>
                  // For most popular setting up null in selected.
                  handleCheck(null, e)
                }
              />
              <p className="pot-value-id">&nbsp;</p>
              <p className="mp-pot-value-head">Total pot</p>
              <p className="mostpop-pot-total-value">
                {`Choose this option to create a single, easy to manage TRA across all your pots.`}
              </p>
            </div>
          </Col>
          <Col lg={1} md={12} sm={1} xs={12}>
            <div className="vertical-line"></div>
            <hr className="pot-hr-line" />
          </Col>
          <Col lg={7} md={6} sm={6} xs={12} className="pots-items-container">
            <p>{"Individual Pots"}</p>
            {individualMembershipData?.map((item, index) => {
              return (
                <Col
                  key={index}
                  className={
                    potItem?.accountId === item.accountId
                      ? "pot-items pot-items-individual mb-3 me-3 pot-items-bg"
                      : "pot-items pot-items-individual mb-3 me-3"
                  }
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <div style={{ display: "flex" }}>
                    <CustomCheckbox
                      defaultChecked={potItem?.accountId === item.accountId}
                      name="pot"
                      potId={index}
                      variantName="custom-checkbox"
                      onChange={(e) => handleCheck(item, e)}
                    />
                    <div className="ms-3 pot-item-account-age-container">
                      <p className="pot-value-id">{item.accountId}</p>
                      <div className="pot-item-account-age">
                        <div>
                          <h6 className="pot-value-head">
                            {getActiveEmployerObj(item)?.employerName}
                          </h6>
                          <p className="pot-value-memberaccount">
                            {item?.active
                              ? "Active"
                              : item?.deffered
                                ? "Deferred"
                                : item?.drawdown
                                  ? "Drawdown"
                                  : ""}
                          </p>
                        </div>
                        <div className="pot-item-account-age">
                          <h6 className="pot-value-age">age</h6>
                          <h6 className="ms-1 pot-value-age-value">
                            {item.retirementAge}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Col>
        </Row>
        <Row>
          <Col lg={12} xs={12}>
            <div className="container-button mt-5">
              <div>
                <Buttons
                  name="Back"
                  className="secondary btn-secondary"
                  handleClick={props.handleCloseButton}
                />
              </div>
              <div>
                <Buttons
                  name="Continue"
                  className="primary"
                  handleClick={props.handleMultipotContinueBtn}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TRAUpdateMultiplePotModal;
